// simple-tooltip.js
;(({ $, $$ }) => {
    CNS.$fns.initSimpleTooltips = function () {
        $$('.simple-tooltip').forEach(tooltip => {
            const parent = tooltip.closest('.drop-down')
            if (!parent) return
    
            const trigger = parent.querySelector('.drop-down__trigger')
            if (!trigger) return
    
            const triggerDim = trigger.getBoundingClientRect()
    
            if (tooltip.classList.contains('simple-tooltip_left')) {
                tooltip.style.left = -30 + triggerDim.width / 2 + 'px'
            } else if (tooltip.classList.contains('simple-tooltip_right')) {
                tooltip.style.right = -30 + triggerDim.width / 2 + 'px'
            }
        })
    }

    CNS.$fns.initSimpleTooltips()
})(CNS);